import React, { useMemo, useState } from 'react';
import {
  MRT_Table,
  type MRT_ColumnDef,
  useMaterialReactTable,
  MaterialReactTable,
  type MRT_ColumnFiltersState,
  type MRT_SortingState,
  type MRT_PaginationState,
} from 'material-react-table';
import {Box, Button, Dialog, DialogContent, DialogTitle, Grid, Typography} from '@mui/material';
import { RepoPrevDett } from './types';
import { useGetRepoPrevDettByPrev } from './Services';
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import PreventiviExp from "./PreventiviExp";
import ReportPrev from "../reportprev/ReportPrev";
import ArticleIcon from "@mui/icons-material/Article";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import DescriptionIcon from '@mui/icons-material/Description';
import TableRowsIcon from '@mui/icons-material/TableRows';


interface PreventiviREProps {
  onClose: () => void;
  idprevtestaprop: number;
}

const PreventiviRE: React.FC<PreventiviREProps> = ({ onClose, idprevtestaprop }) => {
  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>([]);
  const [globalFilter, setGlobalFilter] = useState('');
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [pagination, setPagination] = useState<MRT_PaginationState>({ pageIndex: 0, pageSize: 15 });

  const { data: { results = [], count } = {}, isError: isLoadingCustElemError, isFetching: isFetchingCustElem, isLoading: isLoadingCustElem } = useGetRepoPrevDettByPrev(pagination, columnFilters, globalFilter, sorting, idprevtestaprop);

  const generateExcelData = () => {
    const data = results.map((repoprevdett) => ({
      id: repoprevdett.id || '',
      codarea: repoprevdett.codarea || '',
      desarea: repoprevdett.desarea || '',
      codmodulo: repoprevdett.codmodulo || '',
      desmodulo: repoprevdett.desmodulo || '',
      numanalisi: repoprevdett.numanalisi || '',
      numconf: repoprevdett.numconf || '',
      numform: repoprevdett.numform || '',
      numtot: repoprevdett.numtot || '',
      noumprep: repoprevdett.numprep || '',
      note: repoprevdett.note ? 'X' : '',
    }));

    return data;
  };

  const openExporterModal = () => {
    setIsDialogExporterOpen(true);
  };

  const [isDialogExporterOpen, setIsDialogExporterOpen] = useState(false);

  const dataStartingWithS = useMemo(() => results.filter(item => item.id && item.id.startsWith('S')), [results]);
  const dataStartingWithC = useMemo(() => results.filter(item => item.id && item.id.startsWith('C')), [results]);


  const [isDialogReportPrevPDF, setIsDialogReportPrevPDF] = useState(false);
  const [isDialogReportPrevXLSX, setIsDialogReportPrevXLSX] = useState(false);
  const [isDialogAnalisiRequisiti, setIsDialogAnalisiRequisiti] = useState(false);




const parseNumber = (value: any): number => {
  if (typeof value === 'string') {
    return parseFloat(value.replace(',', '.')) || 0;
  }
  return Number(value) || 0;
};

const calculateTotals = (data: RepoPrevDett[]) => {
  const totals = { numanalisi: 0, numconf: 0, numform: 0, numtot: 0, numprep: 0 };

  data.forEach((item, index) => {
    // console.log(`Item ${index}:`, item);

    totals.numanalisi += parseNumber(item.numanalisi);
    totals.numconf += parseNumber(item.numconf);
    totals.numform += parseNumber(item.numform);
    totals.numtot += parseNumber(item.numtot);
    totals.numprep += parseNumber(item.numprep);
  });

  // console.log("Calculated totals:", totals);
  return totals;
};

  const totalsS = useMemo(() => calculateTotals(dataStartingWithS), [dataStartingWithS]);
  const totalsC = useMemo(() => calculateTotals(dataStartingWithC), [dataStartingWithC]);

      const handleClose = () => {
            onClose();
          };




  const columns = useMemo<MRT_ColumnDef<RepoPrevDett>[]>(
  () => [
    {
      accessorKey: 'id',
      header: 'Id',
      enableEditing: false,
      size: 80,
    },
    {
      accessorKey: 'codarea',
      header: 'CodArea',
      enableEditing: false,
      size: 50,
    },
    {
      accessorKey: 'desarea',
      header: 'Area',
      enableEditing: false,
      size: 300,
    },
    {
      accessorKey: 'codmodulo',
      header: 'CodModulo',
      enableEditing: false,
      size: 50,
    },
    {
      accessorKey: 'desmodulo',
      header: 'Modulo',
      enableEditing: false,
      size: 300,
    },
    {
      accessorKey: 'numanalisi',
      header: 'Analisi',
      enableEditing: false,
      size: 10,
      muiTableBodyCellProps: { align: 'right' },
      muiTableFooterCellProps: { align: 'right' },
      Footer: () => <Box>{(totalsS.numanalisi ?? 0)}</Box>,
    },
    {
      accessorKey: 'numconf',
      header: 'Conf.',
      enableEditing: false,
      size: 10,
      muiTableBodyCellProps: { align: 'right' },
      muiTableFooterCellProps: { align: 'right' },
      Footer: () => <Box>{(totalsS.numconf ?? 0)}</Box>,
    },
    {
      accessorKey: 'numform',
      header: 'Form.',
      enableEditing: false,
      size: 10,
      muiTableBodyCellProps: { align: 'right' },
      muiTableFooterCellProps: { align: 'right' },
      Footer: () => <Box>{(totalsS.numform ?? 0)}</Box>,
    },
    {
      accessorKey: 'numtot',
      header: 'Totale',
      enableEditing: false,
      size: 10,
      muiTableBodyCellProps: { align: 'right' },
      muiTableFooterCellProps: { align: 'right' },
      Footer: () => <Box>{(totalsS.numtot ?? 0)}</Box>,
    },
    {
      accessorKey: 'numprep',
      header: 'Prep.',
      enableEditing: false,
      size: 10,
      muiTableBodyCellProps: { align: 'right' },
      muiTableFooterCellProps: { align: 'right' },
      Footer: () => <Box>{(totalsS.numprep ?? 0)}</Box>,
    },



    {
      accessorKey: 'note',
      header: 'Note',
      enableEditing: false,
      size: 365,
    },
    ],
   [totalsS]
  );

  const columnsWithSumS = useMemo<MRT_ColumnDef<RepoPrevDett>[]>(
    () => columns,
    [columns]
  );



  const columnsWithSumC = useMemo<MRT_ColumnDef<RepoPrevDett>[]>(
    () => columns.map((column) => ({
      ...column,
      Footer: column.accessorKey && ['numanalisi', 'numconf', 'numform', 'numtot','numprep'].includes(column.accessorKey) ? () => (
        <Box >{(totalsC[column.accessorKey as keyof typeof totalsC] ?? 0)}</Box>
      ) : undefined,
    })),
    [columns, totalsC]
  );

  const tableProps = {
    enableRowSelection: false,
    enableColumnActions: false,
    enableColumnFilters: false,
    enablePagination: false,
    enableSorting: false,
    enableTopToolbar: false,
    enableBottomToolbar: false,
    enableColumnResizing: false,
    initialState: { density: 'compact' as const },
    muiTableBodyRowProps: { hover: false },
    muiTableHeadCellProps: {
      sx: {
        border: '1px solid rgba(81, 81, 81, .5)',
        backgroundColor: 'lightgrey',
        fontStyle: 'italic',
        fontWeight: 'bold',
      },
    },
    muiTableBodyCellProps: {
        style: {
          border: '1px solid rgba(81, 81, 81, .5)',

     },

    },

    muiTableFooterCellProps: {
        sx: {
        border: '1px ' +'solid rgba(81, 81, 81, .5)',
        color: 'red',
        align: 'right',
        fontSize: 18,
        fontWeight: 'bold',
      },
    },
  };

  const tableStartingWithS = useMaterialReactTable({
    columns: columnsWithSumS,
    ...tableProps,
    data: dataStartingWithS,
    layoutMode: 'grid-no-grow',
  });

  const tableStartingWithC = useMaterialReactTable({
    columns: columnsWithSumC,
    ...tableProps,
    data: dataStartingWithC,
    layoutMode: 'grid-no-grow',
  });

  return (
    <Dialog onClose={onClose} open fullWidth={true} maxWidth="xl">
      <DialogTitle>
  <Typography variant="h5">Preventivo {idprevtestaprop}</Typography>
  <Box display="flex" justifyContent="space-between" alignItems="center">
    <Box>
      <Button onClick={openExporterModal} startIcon={<FileDownloadIcon />}>EXPORT DATI</Button>
      {isDialogExporterOpen && <PreventiviExp pagination={pagination} columnFilters={columnFilters} globalFilter={globalFilter} sorting={sorting} onClose={() => setIsDialogExporterOpen(false)} idprevtestaprop={idprevtestaprop} />}

      <Button onClick={() => {setIsDialogReportPrevXLSX(true);}} startIcon={<TableRowsIcon />}>Preventivo XLSX</Button>
      {isDialogReportPrevXLSX && <ReportPrev idprev={idprevtestaprop} formato="xlsx" onClose={() => setIsDialogReportPrevXLSX(false)} />}

      <Button onClick={() => {setIsDialogReportPrevPDF(true);}} startIcon={<PictureAsPdfIcon />}>Preventivo PDF </Button>
      {isDialogReportPrevPDF && <ReportPrev idprev={idprevtestaprop} formato="pdf" onClose={() => setIsDialogReportPrevPDF(false)} />}

      <Button onClick={() => {setIsDialogAnalisiRequisiti(true);}} startIcon={<DescriptionIcon />}>Analisi Requisiti</Button>
      {isDialogAnalisiRequisiti && <ReportPrev idprev={idprevtestaprop} formato="anareq" onClose={() => setIsDialogAnalisiRequisiti(false)} />}


    </Box>
    <Button variant="contained" onClick={handleClose} color="error">
      CHIUDI
    </Button>
  </Box>
</DialogTitle>
      <DialogContent>
        <div>
          <Typography variant="h6">Service Elements TS</Typography>
          <MaterialReactTable table={tableStartingWithS} />
        </div>
        <div>
          <Typography variant="h6">Attività Aggiuntive</Typography>
          <MaterialReactTable table={tableStartingWithC} />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PreventiviRE;
